export default __webpack_public_path__ + "static/media/IMG_5306.de37a25f.WEBP";